import appGlobalScript from 'D:/code/agents-sdk/packages/pcm-agents/src/utils/init.ts';
export const globalScripts = appGlobalScript;
